import { render, staticRenderFns } from "./WonderTable.vue?vue&type=template&id=b9f72a20&scoped=true&"
import script from "./WonderTable.vue?vue&type=script&language=javascript&lang=js&"
export * from "./WonderTable.vue?vue&type=script&language=javascript&lang=js&"
import style0 from "./WonderTable.vue?vue&type=style&index=0&id=b9f72a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f72a20",
  null
  
)

export default component.exports